module.exports = __webpack_public_path__ + "static/media/Pick-up.ccdc6461.mp4";